import React, { useEffect, useState } from "react";
import { getTermsAndConditions } from "../../../services/cmsPage.service";
import "./style.scss";


const TermsCondition = () => {

    const [termConditionData, setTermConditionData] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getTermsAndConditions();

                setTermConditionData(Array.isArray(response) ? response : []);
                setLoading(false);
            }
            catch (error: any) {
                console.error("Error fetching data:", error);
                setLoading(false);
            }
        };
        fetchData();
    }, []);


    return (
        <>
            <div className="main-wrapper terms-page innerpagebg">
                <section className="banner-section">
                    <div className="container">
                        <div className="row ">
                            <div className="col-md-12 ">
                                <div className="main-heading d-flex justify-content-center align-items-center">
                                    <h1 className="hero-title">Terms & Conditions</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {loading ? (
                    <section className="py-5 bg-light">
                        <div className="container">
                            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
                                <div
                                    className="spinner-border text-primary"
                                    role="status"
                                    style={{ width: "3rem", height: "3rem" }}
                                >
                                    <span className="visually-hidden">Loading…</span>
                                </div>
                            </div>
                        </div>
                    </section>
                ) : (
                    <>
                        <section className="privacy-policy-text-section ">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12 mb-12">

                                        {termConditionData.map((item, index) => {
                                            const hasHtml = /<\/?[a-z][\s\S]*>/i.test(item.content);

                                            return (
                                                <div key={index} className="mb-4">
                                                    {hasHtml ? (
                                                        <div
                                                            dangerouslySetInnerHTML={{ __html: item.content }}
                                                            className="policy-html"
                                                        />
                                                    ) : (
                                                        <p>{item.content}</p>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </section>  
                    </>
                )}
            </div>
        </>
    );
};

export default TermsCondition;
